import React from "react";
import { Helmet } from "react-helmet";
import Layout from "../../components/layout";
import ComisionesTycPagadasPage from "../../components/comisionesTycPagadas";

interface Props {}

interface State {}

class ComisionesTycPagadas extends React.Component<Props, State> {
  state = {};

  render() {
    return (
      <main>
        <Helmet title="Reporte de comisiones pagadas" />
        <Layout>
          <ComisionesTycPagadasPage />
        </Layout>
      </main>
    );
  }
}

export default ComisionesTycPagadas;
